export default {
	count:{
		sytMoney:0,
		sytNum:0,
		vmallMoney:0,
		vmallNum:0
	}
}



// WEBPACK FOOTER //
// ./src/store/mg/home/state.js